import { render, staticRenderFns } from "./CalculadoraPisoFrete.vue?vue&type=template&id=c1cc73c2&scoped=true"
import script from "./CalculadoraPisoFrete.vue?vue&type=script&lang=js"
export * from "./CalculadoraPisoFrete.vue?vue&type=script&lang=js"
import style0 from "./CalculadoraPisoFrete.vue?vue&type=style&index=0&id=c1cc73c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cc73c2",
  null
  
)

export default component.exports